const PEERING_PREVIEW_KEY = "tf_peering_preview";

export const isPeeringPreviewEnabled = () => {
  try {
    if (typeof window === "undefined") return false;
    const params = new URLSearchParams(window.location?.search || "");
    if (params.get("peering") === "1") {
      window.sessionStorage?.setItem(PEERING_PREVIEW_KEY, "1");
    }
    return window.sessionStorage?.getItem(PEERING_PREVIEW_KEY) === "1";
  } catch {
    return false;
  }
};

export const isMobilePeeringVisible = (user) =>
  !!window?.electronAPI || isPeeringPreviewEnabled();
